import _ from 'lodash';

const getters = {
  cart: (state) => state.added,
  cartOrder: (state) => state.added.map(
    (product) => ({
      id: product.id,
      ref: product.codeSupplier,
      name: product.name,
      uc: product.uc,
      quantity: product.quantity,
      prix: product.price,
      ean: product.ean,
      conditionning: product.conditionning,
    }),
  ),
  cartBySupplier: (state) => _.groupBy(state.added.map((product) => ({
    id: product.id,
    ref: product.codeSupplier,
    quantity: product.quantity,
    name: product.name,
    packaging: product.packaging,
    uc: product.uc,
    supplier: product.supplier,
    prix: product.price,
    ean: product.ean,
    conditionning: product.conditionning,
    realPrice: product.price * product.quantity * product.conditionning,
  })), 'supplier'),
  cartTotalSumHt: (state) => {
    let priceHt = 0;
    state.added.forEach(
      (product) => {
        const priceProduct = product.price * product.quantity * product.conditionning;
        priceHt += priceProduct;
      },
    );
    return priceHt;
  },
  numberOfItemsInCart: (state) => (state.added ? _.size(state.added) : 0),
};
export default getters;
